module.exports = __webpack_public_path__ + "img/icon-login.0d2b8605.svg";